import { OperationalHourCounter } from "app/data/helpers/operationalHoursHelpers";

export interface OperationalHourCounterConfig {
  counter: OperationalHourCounter;
  metadataUniqueId: string;
  labelKey: string;
}

export const OPERATIONAL_HOUR_COUNTER_CONFIG: OperationalHourCounterConfig[] = [
  {
    counter: "RunningHours",
    metadataUniqueId: "3b0a3e75-acbc-4d5e-963e-b653fd796be0",
    labelKey: "typography.operationalWorkingHours"
  },
  {
    counter: "IgnitionHours",
    metadataUniqueId: "0b542f53-78b3-4acc-b47b-262e9a9761d8",
    labelKey: "typography.operationalIgnitionHours"
  },
  {
    counter: "PtoHours",
    metadataUniqueId: "bef5a481-4f1e-4704-ba73-40b7bd0808e5",
    labelKey: "typography.operationalPtoHours"
  }
];
